import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdHocInstructionDTO } from 'src/app/core/Dtos/ad-hoc/adhoc-instruction-dto';
import { AdHocInstructionRetailD2Forecast } from 'src/app/core/Dtos/ad-hoc/adhoc-instruction-retail-d2-forecast';
import { AdHocInstructionRetailDTO } from 'src/app/core/Dtos/ad-hoc/adhoc-instruction-retail-dto';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { FileAttachmentDTO } from 'src/app/core/Dtos/file-attachment-dto';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { GeneralDataService } from 'src/app/core/services/general-data.service';

@Component({
    selector: 'app-ad-hoc-retail',
    templateUrl: './ad-hoc-retail.component.html',
    styleUrl: './ad-hoc-retail.component.scss',
    standalone: false
})
export class AdHocRetailComponent {
  public Instruction: AdHocInstructionRetailDTO = new AdHocInstructionRetailDTO();
  public FileToUpload: File | null = null;
  public DateRangeError: string = "";
  public Asset: Assets;
  public Assets = Assets; // Export enum to UI

  private _filesToUpload: File[] = [];
  constructor(
    private _adhocService: AdHocInstructionsService,
    private _alertService: AlertsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    public DateFormatHelper: DateFormatHelperService
  ) {
    this.Asset = Assets.Retail;
    this.Instruction.issuedTo = this.Instruction.issuedFrom;

    let id = _activatedRoute.snapshot.paramMap.get("id");
    if (id !== null)
      this.GetInstruction(parseInt(id));
    else{this.Instruction.forecasts.push( new AdHocInstructionRetailD2Forecast());}
  }

  GetInstruction(id: number) {
    this._adhocService.GetRetailInstructionById(id).subscribe(
      resp => {
        this.Instruction = resp;
        this.Instruction.files = [];
        this.Instruction.forecasts = [];
      }
    )
  }

  public SaveInstruction() {
    if (!this.ValidateInstruction())
      return;

    if (this.Instruction.issuedTo == "")
      this.Instruction.issuedTo = null;

    if (this._filesToUpload.length > 0)
      this._adhocService.SaveRetailInstructionsWithAttachments(this.Instruction, this._filesToUpload).subscribe(
        resp => this.Cancel()
      );
    else
      this._adhocService.SaveRetailInstruction(this.Instruction).subscribe(
        resp => this.Cancel()
      );
  }

  private ValidateInstruction(): boolean
  {
    let sErr:string[] = [];

    if ((this.Instruction.issuedFrom ?? "") == "")
      sErr.push("Issued From");
    if ((this.Instruction.issuedTo ?? "") == "")
      sErr.push("Issued To");
    if ((this.Instruction.subject ?? "") == "")
      sErr.push("Subject");

    if (sErr.length != 0)
    {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, `The following fields are missing: \n\r ${sErr.join(", ")} `));
      return false;
    }
    return true;
  }

  public AddFile() {
    if (this.FileToUpload == null) {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Warning, "No file selected"));
      return;
    }

    this.Instruction.files.push({ fileId: "", fileName: this.FileToUpload.name });
    this._filesToUpload.push(this.FileToUpload);
    this.FileToUpload = null;
  }

  public RemoveFile(atIndex: number) {
    let ix: number = this._filesToUpload.findIndex(fu => fu.name == this.Instruction.files[atIndex].fileName)
    if (ix != -1)
      this._filesToUpload.splice(ix, 1);

    this.Instruction.files.splice(atIndex, 1);
  }

  public Cancel() {
    this._router.navigate(["retail"]);
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.FileToUpload = file;
    }
  }

  public onDatesChange() {
    this.Instruction.forecasts = [];
    if (this.Instruction.issuedFrom == "" || this.Instruction.issuedTo == "")
      return;

    let from: Date = this.DateFormatHelper.StripTimeFromDate(new Date(this.Instruction.issuedFrom)),
      to: Date = this.DateFormatHelper.StripTimeFromDate(new Date(this.Instruction.issuedTo ?? ""));
    // If date range is greater than 6 days, return early
    if ((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24) > 5) {
      this.DateRangeError = "Date range cannot exceed 6 days";
      return;
    }

    this.DateRangeError = "";
    while (from <= to)
      {
        let fc: AdHocInstructionRetailD2Forecast = new AdHocInstructionRetailD2Forecast();
        fc.forecastDate = this.DateFormatHelper.GetAPIFormat(from);
        this.Instruction.forecasts.push(fc);
        from.setDate(from.getDate() + 1);
      }
  }
}